<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5>Daftar Reject Gadai</h5>
      </template>
      <div class="big-filter-label filter-form-wrapper mb-3">
        <b-row>
          <b-col md="12" lg="9">
            <b-form-group class="form-inline" label-for="filterImeiSn" label="Id">
              <b-form-input
                v-model="input.filterId"
                name="filterId"
                type="search"
                id="filterId"
                placeholder="Masukkan Id"
              ></b-form-input>
            </b-form-group>
            <b-form-group class="form-inline" label-for="filterCabangId" label="Cabang">
              <div label="Filter Cabang">
                <multiselect
                  class="ml-0"
                  name="filterCabangId"
                  v-model="input.filterCabangId"
                  :options="cabangOption"
                  :internal-search="true"
                  :allow-empty="true"
                  deselect-label=""
                  select-label=""
                  label="name"
                  track-by="name"
                  placeholder="-- Pilih filter cabang --"
                />
              </div>
            </b-form-group>
            <b-form-group
              class="form-inline filter-form-date"
              label-for="filterDate"
              label="Tanggal"
            >
              <div class="d-flex search-input-wrapper">
                <b-form-input
                  v-model="input.filterStartDate"
                  name="filterStartDate"
                  id="filterDate"
                  type="date"
                ></b-form-input>
                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                <b-form-input
                  v-model="input.filterEndDate"
                  name="filterEndDate"
                  type="date"
                ></b-form-input>
              </div>
            </b-form-group>
            <b-form-group class="form-inline" label-for="filterImeiSn" label="IMEI">
              <b-form-input
                v-model="input.filterImeiSn"
                name="filterImeiSn"
                type="search"
                id="filterImeiSn"
                placeholder="Masukkan no. IMEI"
              ></b-form-input>
            </b-form-group>
            <b-form-group class="form-inline" label-for="filterTergadai" label="Status">
              <b-form-select
                v-model="input.filterTergadai"
                id="filterTergadai"
                name="status"
                :options="statusOption"
                value-field="value"
                text-field="name"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled
                    >Pilih Status</b-form-select-option
                  >
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group
              class="form-inline"
              label-for="filterIsTipeTidakTerdaftar"
              label="Tipe tidak terdaftar"
            >
              <b-form-select
                v-model="input.filterIsTipeTidakTerdaftar"
                id="filterIsTipeTidakTerdaftar"
                name="status"
                :options="tipeTidakTerdaftarOpt"
                value-field="value"
                text-field="name"
              >
              </b-form-select>
            </b-form-group>

            <div class="multiselect-custom-wrapper">
              <label>Jenis Barang</label>
              <MultiSelectDropdown
                id="filterJenisId"
                v-model="input.filterJenisId"
                :options="jenisBarangOpt"
                text-field="name"
                value-field="id"
                placeholder="Pilih Jenis Barang"
                class="msd multiselect-custom"    
                :menu-class="'p-0 msd-menu'"   
              />
            </div>

          </b-col>
          <b-col cols="12">
            <div class="filter-btn-wrapper">
              <b-button
                class="mr-2"
                variant="pgiBtn"
                name="searchTableBtn"
                :disabled="isBusy"
                @click="onFilter()"
              >
                Search
              </b-button>
              <b-button
                variant="pgiBtn"
                name="resetTableBtn"
                :disabled="isBusy"
                @click="onReset"
                >Reset</b-button
              >
            </div>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="pgiBtn"
            class="mb-0 download-btn"
            @click="modalDownload"
            :disabled="isBusy"
          >
            <i class="fa fa-download mr-2"></i>
            Download Excel
          </b-button>
          <a
            v-bind:href="$baseFilePath + filePathDownload"
            hidden
            id="downloadExcel"
            download
          >
            <i class="fa fa-download mr-2"></i>
            Download Excel
          </a>
        </div>
      </div>

      <b-table
        bordered
        hover
        show-empty
        :busy="isBusy"
        :items="daftarReject"
        :fields="fields"
        :no-local-sorting="false"
        @sort-changed="sortingChanged"
        responsive
        class="mb-3"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Loading data...</strong>
          </div>
        </template>
        <template v-slot:empty> Tidak ada data reject gadai. </template>

        <template v-slot:cell(tanggal)="row">
          <div v-if="row.item.createdAt != null">
            {{ $helper.changeDateFormat(row.item.createdAt) }}
          </div>
          <div v-else>-</div>
          <div class="mb-0 smallText text-muted">
            {{ $helper.hourMinuteSecond(row.item.createdAt) }} WIB
          </div>
        </template>
        <template v-slot:cell(cabang)="row">
          <div>{{ row.item.cabang }}</div>
          <p class="mb-0 smallText text-muted">
            Dibuat oleh: {{ row.item.createdBy || "-" }}
          </p>
        </template>
        <template v-slot:cell(reason)="row">
          <div v-if="row.item.reason != null">{{ row.item.reason }}</div>
          <div v-else>-</div>
          <b-badge variant="success" v-if="row.item.noFaktur != null">TERGADAI</b-badge>
        </template>
        <template v-slot:cell(namaNasabah)="row">
          <p class="mb-0">{{ row.item.namaNasabah }}</p>
          <p class="mb-0 smallText text-muted">Hp : {{ row.item.noHandphoneNasabah }}</p>
        </template>
        <template v-slot:cell(barang)="row">
          {{ row.item.jenis + " - " + row.item.merk + " - " + row.item.tipe }}
          <p class="mb-0 smallText text-muted">
            Imei : {{ row.item.imeiSn }}
            {{
              row.item.spekBarang != null
                ? row.item.spekBarang == 2
                  ? "( RESMI )"
                  : "( LN )"
                : ""
            }}
          </p>
          <b-badge variant="primary" v-if="row.item.isTipeTidakTerdaftar == true"
            >Tidak Terdaftar</b-badge
          >
        </template>
        <template v-slot:cell(pinjaman)="row">
          Max : Rp. {{ $helper.addThousandSeparator(row.item.pinjamanMaksimal) }}
          <p class="mb-0 smallText text-muted">
            Kebutuhan : Rp.
            {{ $helper.addThousandSeparator(row.item.pinjamanKebutuhanNasabah) }}
          </p>
        </template>

        <template v-slot:cell(action)="row">
          <div class="no-wrap">
            <b-button
              size="sm"
              class="mr-3 table-button view"
              v-b-tooltip.hover
              title="Detail"
              @click="detailReject(row.item)"
              name="tipeBarangViewBtn"
            >
              <i class="fa fa-info"></i>
            </b-button>
          </div>
        </template>
      </b-table>

      <div class="pagination-wrapper d-flex align-items-center justify-content-between">
        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
          <b-form-select
            v-model="input.show"
            id="showItems"
            @change="onLimitChange"
            :options="options"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled />
            </template>
          </b-form-select>
          <span class="ml-2">{{ totalViewText }}</span>
        </b-input-group>
        <b-pagination
          class="mb-0"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          @input="onPageChange"
        ></b-pagination>
      </div>
    </b-card>

    <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
      <div class="detail-data-wrapper mb-3">
        <h6 class="form-title mb-1">SURAT</h6>
        <p class="smallText mb-0">
          Surat penarikan sudah disiapkan untuk nomor faktur ini. Menunggu tindak lanjut
          dari tim penarikan.
        </p>
      </div>
      <div class="detail-data-wrapper mb-3">
        <h6 class="form-title mb-1">DI CABANG</h6>
        <p class="smallText mb-0">
          Kendaraan sudah ditarik dan sedang disimpan di cabang.
        </p>
      </div>
      <div class="detail-data-wrapper mb-0">
        <h6 class="form-title mb-1">DI PUSAT</h6>
        <p class="smallText mb-0">Kendaraan sudah dikirim dan disimpan di Pusat</p>
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
          Tutup
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="detail-reject"
      title="Detail Reject Gadai"
      size="lg"
      ok-only
      ok-title="Tutup"
      no-close-on-backdrop
    >
      <div v-if="activeData != null" class="detail-data-wrapper mb-4 mt-4">
        <h6 class="form-title mb-2">DATA NASABAH</h6>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Nama</b-col>
          <b-col>
            {{ activeData.namaNasabah }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">No. Hp</b-col>
          <b-col>
            {{
              activeData.noHandphoneNasabah != null || activeData.noHandphoneNasabah != ""
                ? activeData.noHandphoneNasabah
                : ""
            }}
          </b-col>
        </b-row>
      </div>
      <div v-if="activeData != null" class="detail-data-wrapper mb-4">
        <h6 class="form-title mb-2">DATA REJECT</h6>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Cabang</b-col>
          <b-col>
            {{ activeData.cabang }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Dibuat oleh</b-col>
          <b-col>
            {{ activeData.createdBy || "-" }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Tanggal</b-col>
          <b-col v-if="activeData.createdAt != null">
            {{ $helper.changeDateFormat(activeData.createdAt) }}
          </b-col>
          <b-col v-else>-</b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Alasan</b-col>
          <b-col>
            {{ activeData.reason != null ? activeData.reason : "" }}
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Keterangan</b-col>
          <b-col>
            {{ activeData.keterangan }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Barang</b-col>
          <b-col>
            {{ activeData.jenis + " - " + activeData.merk + " - " + activeData.tipe }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">IMEI / SN / Nomor BPKB</b-col>
          <b-col>
            {{ activeData.imeiSn }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Spek</b-col>
          <b-col>
            {{
              activeData.spekBarang ? (activeData.spekBarang == 2 ? "RESMI" : "LN") : "-"
            }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">No. Model</b-col>
          <b-col>
            {{ activeData.modelNumber ? activeData.modelNumber : "-" }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Kondisi</b-col>
          <b-col>
            {{ activeData.kondisi }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Spesifikasi</b-col>
          <b-col v-if="activeData.spesifikasi != null">
            {{ activeData.spesifikasi }}
          </b-col>
          <b-col v-else>-</b-col>
        </b-row>
        <b-row class="mb-2" v-if="activeData.dataEmas != null">
          <b-col cols="5" class="detail-data-label">Data Emas</b-col>
          <b-col v-if="activeData.dataEmas != null">
            {{ activeData.dataEmas }}
          </b-col>
          <b-col v-else>-</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Pinjaman Maksimal</b-col>
          <b-col>
            Rp. {{ $helper.addThousandSeparator(activeData.pinjamanMaksimal) }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Kebutuhan Nasabah</b-col>
          <b-col>
            Rp. {{ $helper.addThousandSeparator(activeData.pinjamanKebutuhanNasabah) }}
          </b-col>
        </b-row>
        <div v-if="activeData.isTipeTidakTerdaftar">
          <b-row class="mb-2">
            <b-col cols="5" class="detail-data-label">Tipe Tidak Terdaftar</b-col>
            <b-col> Ya </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="5" class="detail-data-label">Nama Tipe Tidak Terdaftar</b-col>
            <b-col>
              {{ activeData.tipe }}
            </b-col>
          </b-row>
        </div>
      </div>

      <div v-if="activeData != null" class="detail-data-wrapper mb-4 mt-4">
        <h6 class="form-title mb-2">DATA GADAI</h6>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">No. Faktur</b-col>
          <b-col v-if="activeData.noFaktur != null">
            {{ activeData.noFaktur }}
          </b-col>
          <b-col v-else>-</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Cabang Gadai</b-col>
          <b-col v-if="activeData.cabangGadai != null">
            {{ activeData.cabangGadai }}
          </b-col>
          <b-col v-else>-</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Tanggal Gadai</b-col>
          <b-col v-if="activeData.tanggalGadai != null">
            {{ $helper.changeDateFormat(activeData.tanggalGadai) }}
          </b-col>
          <b-col v-else>-</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Pinjaman Maks. Gadai</b-col>
          <b-col v-if="activeData.pinjamanMaksimalGadai != null">
            Rp. {{ $helper.addThousandSeparator(activeData.pinjamanMaksimalGadai) }}
          </b-col>
          <b-col v-else>-</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="5" class="detail-data-label">Pinjaman Diambil</b-col>
          <b-col v-if="activeData.pinjamanMaksimalGadai != null">
            Rp. {{ $helper.addThousandSeparator(activeData.pinjamanMaksimalGadai) }}
          </b-col>
          <b-col v-else>-</b-col>
        </b-row>
      </div>

      <div v-if="foto.length != 0" class="detail-data-wrapper mb-4 mt-4">
        <h6 class="form-title mb-2">FOTO REJECT</h6>
        <ModalFoto isButton withLength :photos="foto" />
      </div>
    </b-modal>

    <ModalConfirm
      id="modal-confirm-download"
      title="Confirm Download Reject Gadai"
      desc="Apakah anda yakin untuk mendownload Reject Gadai ini?"
      @submit="onDownloadOrder()"
    />
    <b-modal
      id="modal-download-reject"
      centered
      title="Download Reject Gadai"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center" v-if="isLoadLink == true">
        <b-spinner class="align-middle mb-4"></b-spinner>
        <p class="mb-0">Sedang memproses, mohon menunggu...</p>
      </div>
      <div class="show-btn-download" v-else>
        <p class="">Silakan download dengan klik tombol dibawah ini :</p>
        <b-button variant="pgiBtn" class="mb-0 download-btn">
          <a v-bind:href="$baseFilePath + filePathDownload" download>
            <i class="fa fa-download mr-2"></i>
            Download Reject Gadai
          </a>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MultiSelectDropdown from "@/components/gadai/MultiSelectDropdown.vue";
import ModalFoto from '@/components/modals/ModalFoto'

export default {
  name: "daftar-penarikan",
  components: { MultiSelectDropdown, ModalFoto },
  data() {
    return {
      initStatus: 0,
      isBusy: true,
      activeData: null,
      filePathDownload: "",
      input: {
        show: 10,
        filterId: null,
        filterCabangId: null,
        filterStartDate: null,
        filterEndDate: null,
        filterImeiSn: null,
        filterTergadai: null,
        sortBy: null,
        sortDesc: null,
        downloadStartDate: null,
        downloadEndDate: null,
        filterIsTipeTidakTerdaftar: null,
        filterJenisId: [],
      },
      fields: [
        { key: "id", label: "Id" },
        { key: "tanggal", label: "Tanggal" },
        { key: "cabang", label: "Cabang" },
        { key: "reason", label: "Alasan" },
        { key: "namaNasabah", label: "Nasabah" },
        { key: "barang", label: "Barang" },
        { key: "pinjaman", label: "Pinjaman" },
        { key: "action", label: "Aksi" },
      ],
      options: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 30, text: "30" },
        { value: 40, text: "40" },
        { value: 50, text: "50" },
      ],
      statusOption: [
        { id: 0, value: true, name: "Tergadai" },
        { id: 1, value: false, name: "Belum Tergadai" },
      ],
      tipeTidakTerdaftarOpt: [
        { id: 2, value: null, name: "Semua" },
        { id: 0, value: true, name: "Tidak Terdaftar" },
        { id: 1, value: false, name: "Terdaftar" },
      ],
      foto: [],

      daftarReject: [],
      cabangOption: [],
      currentPage: 1,
      perPage: 10,
      rows: null,
      totalViewText: "",
      page: "",
      size: "",
      cabangId: "",
      loading: false,
      query: "",
      isLoadLink: false,
    };
  },
  methods: {
    //----------------- Fungsi Inisialisasi -----------------

    init() {
      this.initStatus = 0;
      this.page = 0;
      this.size = this.input.show;
      this.query = this.$helper.makeQuery(this.page, this.size);
      this.cabangId = this.$helper.getCabangId();
      this.query = this.query + "&cabangId=" + this.cabangId;

      let getCabang = localStorage.getItem("cabang");
      this.cabangOption = JSON.parse(getCabang);

      let getJenisBarang = this.$axios.get("barang-jenis/").then((response) => {
        this.jenisBarangOpt = response.data;
      });
      let getDaftarReject = this.$axios
        .get("gadai-reject/" + this.query)
        .then((response) => {
          this.daftarReject = response.data.data;
          this.updateTotalItem(response.data.total);
          let msg = this.$helper.getFlash();
          this.$helper.toastSucc(this, msg);
        });

      Promise.all([getDaftarReject, getJenisBarang])
        .then(() => {
          this.initStatus = 1;
          this.toggleBusy();
        })
        .catch((error) => {
          this.initStatus = -1;
          this.toggleBusy();
        });
    },

    detailReject(item) {
      this.activeData = item;
      this.getFoto(item);
      this.$bvModal.show("detail-reject");
    },

    getFoto(item) {
      this.$axios
        .get("gadai-reject/photo/" + item.id)
        .then((response) => {
          this.foto = response.data;
        })
        .catch((error) => {
          this.initStatus = -1;
          this.toggleBusy();
        });
    },
    //----------------- Fungsi Ambil Data Daftar Gadai -----------------

    getDaftarReject() {
      this.toggleBusy();
      this.daftarReject = [];

      if (this.$helper.isNotNullAndNotEmpty(this.input.filterId))
        this.query = this.query + "&filterId=" + this.input.filterId;
      if (this.$helper.isNotNullAndNotEmpty(this.input.filterCabangId))
        this.query = this.query + "&filterCabangId=" + this.input.filterCabangId.id;
      if (this.$helper.isNotNullAndNotEmpty(this.input.filterStartDate))
        this.query = this.query + "&filterStartDate=" + this.input.filterStartDate;
      if (this.$helper.isNotNullAndNotEmpty(this.input.filterEndDate))
        this.query = this.query + "&filterEndDate=" + this.input.filterEndDate;
      if (this.$helper.isNotNullAndNotEmpty(this.input.filterJenisId))
        this.query = this.query + "&filterJenisId=" + this.input.filterJenisId;
      if (this.input.filterImeiSn != null)
        this.query = this.query + "&filterImeiSn=" + this.input.filterImeiSn;
      if (this.input.filterTergadai != null)
        this.query = this.query + "&filterTergadai=" + this.input.filterTergadai;
      if (this.input.sortBy != null)
        this.query = this.query + "&sortBy=" + this.input.sortBy;
      if (this.input.sortDesc != null)
        this.query = this.query + "&sortDesc=" + this.input.sortDesc;
      if (this.input.filterIsTipeTidakTerdaftar != null)
        this.query =
          this.query +
          "&filterIsTipeTidakTerdaftar=" +
          this.input.filterIsTipeTidakTerdaftar;

      this.$axios
        .get("gadai-reject/" + this.query)
        .then((response) => {
          this.daftarReject = response.data.data;
          this.toggleBusy();
          this.updateTotalItem(response.data.total);
          this.loading = false;
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
          this.toggleBusy();
          this.loading = false;
        });
    },

    modalDownload() {
      if (this.input.filterStartDate == null) {
        return this.$helper.toastErr(
          this,
          "Mohon isi tanggal penarikan mulai dan tanggal penarikan akhir filter!"
        );
      }
      if (this.input.filterEndDate == null) {
        return this.$helper.toastErr(
          this,
          "Mohon isi tanggal penarikan mulai dan tanggal penarikan akhir filter!"
        );
      }

      const startDate = new Date(this.input.filterStartDate);
      const endDate = new Date(this.input.filterEndDate);

      if (endDate < startDate) {
        return this.$helper.toastErr(
          this,
          "Tanggal Dari tidak boleh melebihi Tanggal Sampai"
        );
      }
      this.$bvModal.show("modal-confirm-download");
    },

    onDownloadOrder() {
      this.isLoadLink = true;
      this.$bvModal.show("modal-download-reject");
      this.$bvModal.hide("modal-confirm-download");
      setTimeout(() => {
        this.axiosDownloadExcel();
      }, 500);
    },

    axiosDownloadExcel() {
      this.page = 0;
      this.size = this.input.show;
      this.query = this.$helper.makeQuery(this.page, this.size);

      if (this.$helper.isNotNullAndNotEmpty(this.input.filterId))
        this.query = this.query + "&filterId=" + this.input.filterId;
      if (this.$helper.isNotNullAndNotEmpty(this.input.filterCabangId))
        this.query = this.query + "&filterCabangId=" + this.input.filterCabangId.id;
      if (this.$helper.isNotNullAndNotEmpty(this.input.filterStartDate))
        this.query = this.query + "&filterStartDate=" + this.input.filterStartDate;
      if (this.$helper.isNotNullAndNotEmpty(this.input.filterEndDate))
        this.query = this.query + "&filterEndDate=" + this.input.filterEndDate;
      if (this.$helper.isNotNullAndNotEmpty(this.input.filterJenisId))
        this.query = this.query + "&filterJenisId=" + this.input.filterJenisId;
      if (this.input.filterImeiSn != null)
        this.query = this.query + "&filterImeiSn=" + this.input.filterImeiSn;
      if (this.input.filterTergadai != null)
        this.query = this.query + "&filterTergadai=" + this.input.filterTergadai;
      if (this.input.sortBy != null)
        this.query = this.query + "&sortBy=" + this.input.sortBy;
      if (this.input.sortDesc != null)
        this.query = this.query + "&sortDesc=" + this.input.sortDesc;
      if (this.input.filterIsTipeTidakTerdaftar != null)
        this.query =
          this.query +
          "&filterIsTipeTidakTerdaftar=" +
          this.input.filterIsTipeTidakTerdaftar;

      this.$axios
        .get("gadai-reject/excel" + this.query)
        .then((response) => {
          this.filePathDownload = response.data.name;
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isLoadLink = false;
        });
    },

    onLimitChange() {
      this.size = this.input.show;
      this.perPage = this.input.show;
      this.currentPage = 1;
      this.page = 0;
      this.query = this.$helper.makeQuery(0, this.size);
      this.getDaftarReject();
    },

    onPageChange() {
      if (this.loading == false) {
        this.page = this.currentPage - 1;
        this.query = this.$helper.makeQuery(this.page, this.size);
        this.getDaftarReject();
      }
    },

    sortingChanged(ctx) {
      if (ctx.sortBy != "") {
        this.input.sortBy = ctx.sortBy;
        this.input.sortDesc = ctx.sortDesc;
        this.onFilter();
      }
    },

    onReset() {
      this.input.filterId = null;
      this.input.filterCabangId = null;
      this.input.filterStartDate = null;
      this.input.filterEndDate = null;
      this.input.filterFromDateKirim = null;
      this.input.filterToDateKirim = null;
      this.input.filterImeiSn = null;
      this.input.filterTergadai = null;
      this.input.filterIsTipeTidakTerdaftar = null;
      this.input.filterJenisId = null;
      this.currentPage = 1;
      this.page = 0;
      this.query = this.$helper.makeQuery(0, this.size);
      this.loading = true;
      this.getDaftarReject();
    },

    onFilter() {
      this.page = 0;
      this.currentPage = 1;
      this.query = this.$helper.makeQuery(0, this.size);
      this.loading = true;
      if (
        this.$helper.isNotNullAndNotEmpty(this.input.filterEndDate) &&
        !this.$helper.isNotNullAndNotEmpty(this.input.filterStartDate)
      ) {
        this.$helper.toastErr(
          this,
          "Mohon isi tanggal penarikan mulai dan tanggal penarikan akhir filter!"
        );
      } else if (
        !this.$helper.isNotNullAndNotEmpty(this.input.filterEndDate) &&
        this.$helper.isNotNullAndNotEmpty(this.input.filterStartDate)
      ) {
        this.$helper.toastErr(
          this,
          "Mohon isi tanggal penarikan mulai dan tanggal penarikan akhir filter!"
        );
      } else if (
        this.$helper.isNotNullAndNotEmpty(this.input.filterEndDate) &&
        this.$helper.isNotNullAndNotEmpty(this.input.filterStartDate) &&
        Date.parse(this.input.filterEndDate) < Date.parse(this.input.filterStartDate)
      ) {
        this.$helper.toastErr(
          this,
          "Tanggal penarikan akhir lebih kecil daripada tanggal penarikan mulai!"
        );
      } else if (
        this.$helper.isNotNullAndNotEmpty(this.input.filterToDateKirim) &&
        !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateKirim)
      ) {
        this.$helper.toastErr(
          this,
          "Mohon isi tanggal set kirim mulai dan tanggal set kirim akhir filter!"
        );
      } else if (
        !this.$helper.isNotNullAndNotEmpty(this.input.filterToDateKirim) &&
        this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateKirim)
      ) {
        this.$helper.toastErr(
          this,
          "Mohon isi tanggal set kirim mulai dan tanggal set kirim akhir filter!"
        );
      } else if (
        this.$helper.isNotNullAndNotEmpty(this.input.filterToDateKirim) &&
        this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateKirim) &&
        Date.parse(this.input.filterToDateKirim) <
          Date.parse(this.input.filterFromDateKirim)
      ) {
        this.$helper.toastErr(
          this,
          "Tanggal set kirim akhir lebih kecil daripada tanggal set kirim mulai!"
        );
      } else {
        this.getDaftarReject();
      }
    },

    //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

    toggleBusy() {
      if (this.isBusy == true) this.isBusy = false;
      else this.isBusy = true;
    },

    updateTotalItem(total) {
      let limit = null;
      let prevLimit = null;
      this.perPage = this.size;
      this.rows = total;
      prevLimit = this.page * this.size + 1;
      limit = this.page * this.size + this.size;
      if (limit > this.rows) limit = this.rows;
      this.totalViewText =
        "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri";
    },
  },

  created() {
    this.init();
  },
};
</script>

<style scoped>
.multiselect-custom-wrapper {
  display: flex;
  margin-bottom: 16px;
}

.multiselect-custom {
  max-width: 251px;
  margin-left: 50px;
}

@media screen and (max-width: 450px) {
  .multiselect-custom-wrapper {
    flex-direction: column;
  }

  .multiselect-custom {
    max-width: 100%;
    margin-left: 0;
  }
}
</style>
